import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { CoreModule } from '@ridango/core';

import { PurchaseHistoryActions, PurchaseHistoryEpics, PurchaseHistoryFacade } from './+state';
import { PurchaseHistoryTableRowComponent } from './components/purchase-history-table-row/purchase-history-table-row.component';
import { PurchaseHistoryTableComponent } from './components/purchase-history-table/purchase-history-table.component';
import { PurchaseHistoryService } from './purchase-history.service';

@NgModule( {
    imports: [
        CoreModule,
        CommonModule,
        TranslateModule
    ],
    declarations: [ PurchaseHistoryTableComponent, PurchaseHistoryTableRowComponent ],
    exports: [ PurchaseHistoryTableComponent ],
    providers: [ PurchaseHistoryService, PurchaseHistoryActions, PurchaseHistoryFacade, PurchaseHistoryEpics ]
} )
export class PurchaseHistoryModule { }
